import { type FC, useState } from 'react'
import styled from 'styled-components'
import RotaTable, { type SortObject } from '../components/RotaTable'
import { VISIT } from '../constants'
import { useRotaPatternsList } from '../hooks/useRotaPatternsList'
import RotaFilters, {
  type RotaFiltersValue
} from '../RotaBuilder/common/components/RotaFilters'

type RotaVisitsTableProps = {
  hasResidentsFilter?: boolean
  residentId?: string
  hasResidentColumn?: boolean
  testId?: string
}

const RotaVisitsTable: FC<RotaVisitsTableProps> = ({
  hasResidentsFilter,
  residentId,
  hasResidentColumn = true,
  testId
}) => {
  const [sortParams, setSortParams] = useState<SortObject>({
    field: 'resident.name.last',
    order: 'ascend'
  })

  const [filterParams, setFilterParams] = useState<RotaFiltersValue>(
    !hasResidentsFilter && residentId ? { subjectIds: [residentId] } : {}
  )

  const { patternList, isLoadingList, pagination, setPage } =
    useRotaPatternsList({
      type: VISIT,
      patternListSorting: sortParams,
      patternListFilters: filterParams
    })

  const onFilterChange = (value: RotaFiltersValue) => {
    setFilterParams((prevFilters) => ({
      ...prevFilters,
      ...value
    }))
  }

  return (
    <Container data-testid={testId}>
      <RotaFilters
        value={filterParams}
        onChange={onFilterChange}
        hasResidentsFilter={hasResidentsFilter}
        filtersType="visit"
      />
      <RotaTable
        tableType="visit"
        patternList={patternList}
        isLoading={isLoadingList}
        pagination={pagination}
        onChange={(page) => setPage(page)}
        onSortChange={setSortParams}
        hasResidentColumn={hasResidentColumn}
      />
    </Container>
  )
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 24px;
`

export default RotaVisitsTable
